import { Dialog, DialogContent, DialogProps } from "@mui/material";
import { Box } from "@mui/system";

import AppModalTitle from "@/common/components/Modals/AppModalTitle";

import GeneralProductProfileOfEntityUpdate, {
  GeneralProductProfileOfEntityUpdateProps,
} from "./GeneralProductProfileOfEntityUpdate";

export interface OwnProps {
  updateProps: GeneralProductProfileOfEntityUpdateProps;
}

type Props = OwnProps & DialogProps;

export default function GeneralProductProfileOfEntityUpdateModal({
  updateProps,
  ...dialogProps
}: Props) {
  return (
    <Dialog fullWidth maxWidth='lg' {...dialogProps}>
      <AppModalTitle
        onClose={() => dialogProps?.onClose && dialogProps?.onClose({}, "escapeKeyDown")}
      >
        Update product profile
      </AppModalTitle>

      <DialogContent>
        <Box sx={{ py: 1 }}>
          <GeneralProductProfileOfEntityUpdate {...updateProps} />
        </Box>
      </DialogContent>
    </Dialog>
  );
}
